module.exports = __webpack_public_path__ + "img/con3.4a5099e9.png";